import {
  ADMIN_LOADING,
  GET_ADMIN,
  GET_ADMIN_ONE,
  GET_ADMIN_SUCCESS,
  GET_ADMIN_FAIL,
  ADD_NEW_ADMIN,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAIL,
  DELETE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAIL,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAIL,
  ADMIN_RESET
} from "./actionType";

const INIT_STATE = {
  admins: [],
  adminOne: {},
  error: {},
};

const admin = (state = INIT_STATE, action) => {

  switch (action.type) {
    case GET_ADMIN_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ADMIN:
          return {
            ...state,
            admins: action.payload.data,
            isAdminCreated: false,
            isAdminSuccess: true,
            loading: false,
          };

        case GET_ADMIN_ONE:
          return {
            ...state,
            adminOne: action.payload.data,
            isAdminCreated: false,
            isAdminSuccess: true,
            loading: false,
          };


        default:
          return { ...state };
      }
    case GET_ADMIN_FAIL:
      switch (action.payload.actionType) {
        case GET_ADMIN_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAdminCreated: false,
            isAdminSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ADMIN: {
      return {
        ...state,
        isAdminCreated: false,
        loading: true,
      };
    }

    case GET_ADMIN_ONE: {
      return {
        ...state,
        adminOne: action.payload.data,
        isAdminCreated: false,
        loading: true,
      };
    }

    case ADMIN_LOADING: {
      return {
        ...state,
        isAdminCreated: false,
        loading: true,
      };
    }

    case ADD_ADMIN_SUCCESS:
      return {
        ...state,
        isAdminCreated: true,
        loading: false,
        admins: [action.payload.data, ...state.admins],
      };

    case ADD_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAdminCreated: true,
        admins: state.admins.filter(
          admin => admin.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAdminCreated: true,
        admins: state.admins.map(admin =>
          admin.id.toString() === action.payload.data.id.toString() ? { ...admin, ...action.payload.data } : admin
        ),
      };

    case UPDATE_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADMIN_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default admin;